import { DriveStep } from "driver.js";

export const tourStepsConfigUser: Record<string, DriveStep[]> = {
  "/dashboard": [
    {
      element: '[data-tour="dashboard"]',
      popover: {
        title: "Dashboard",
        description: `
  <p>The <strong>Dashboard</strong> provides a quick overview of your survey activities, including the number of forms you have filled, pending forms, and their respective start and end dates.</p>
`,
      },
    },
  ],
};
